import React, {useState, useContext, useEffect} from 'react';
import {useNavigate} from 'react-router-dom'
import PlaylistContext from "../../../Context/PlaylistContext";

function AlbumSong(props) {
    const navigate = useNavigate();
    const [isHover, setIsHover] = useState(false)
    const [isActive, setIsActive] = useState(false)

    const {playlist, setPlaylist} = useContext(PlaylistContext);

    useEffect(() => {
        props.song.id === playlist.id ? setIsActive(true) : setIsActive(false)
    }, [playlist]);

    const updatePlaylist = async () => {
        setPlaylist([props.song])
    }

    return (
        <div
            className={`${isHover || isActive ? 'bg-violet-500 text-white' : 'bg-violet-100'} flex flex-row justify-between px-4 py-2 rounded-lg w-full text-sm transition duration-75 cursor-pointer`}
            /*onClick={() => navigate(`/song/${props.id}`)}*/
            /*onClick={() => navigate(`/song/${props.id}`)}*/
            onClick={updatePlaylist}
            onMouseOver={() => setIsHover(true)}
            onMouseOut={() => setIsHover(false)}
        >
            <div className="flex flex-row items-center">
                <div className="flex justify-center w-[20px] ml-2">
                    {
                        isActive
                            ? <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                                   stroke="currentColor" className="w-4 h-4">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25v13.5m-7.5-13.5v13.5"/>
                              </svg>

                            : isHover
                                ? <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                       strokeWidth={1.5}
                                       stroke="currentColor" className="w-4 h-4">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"/>
                                </svg>
                                : <div className='text-stone-500'>{props.index + 1}</div>

                    }
                </div>
                <div>{props.song.name}</div>
            </div>

            <div className={`${isHover || isActive ? 'text-white' : 'text-stone-500'}`}>{props.song.time}</div>
        </div>
    );
}

export default AlbumSong;